/* eslint-disable space-before-function-paren */
/* eslint-disable keyword-spacing */
import { get } from '../../api';
import { buildUrl } from '../request.utils';

// const mockCities = {
//     data: [
//         {
//             zipcode: null,
//             number_of_intersections: null,
//             maestro_pk: null,
//             installed_date: null,
//             timezone: null,
//             ip_address: null,
//             contact_person: null,
//             contact_email: null,
//             details: {
//                 center: {
//                     lat: 45.52,
//                     lng: 45.52
//                 }
//             },
//             status_schema: null,
//             maestros: null,
//             redis_mapping: null
//         },
//         {
//             zipcode: null,
//             number_of_intersections: null,
//             maestro_pk: null,
//             installed_date: null,
//             timezone: null,
//             ip_address: null,
//             contact_person: null,
//             contact_email: null,
//             details: {
//                 center: {
//                     lat: 45.5,
//                     lng: 45.5
//                 }
//             },
//             status_schema: null,
//             maestros: null,
//             redis_mapping: null
//         }
//     ],
//     pagination: {
//         count: 2,
//         offset: 0,
//         limit: 0
//     }
// };

// const mockAgencies = {
//     data: [
//         {
//             agencies_id: 'trimet',
//             agencies_short_name: 'TriMet',
//             agencies_long_name: 'TriMet',
//             code: null,
//             url: null,
//             description: null
//         }
//     ]
// };

export const getCities = async (params = {}) => {
    const {id, name} = params;
    const searchParams = new URLSearchParams();
    searchParams.append('offset', '0');
    searchParams.append('limit', '1000');
    if (id) searchParams.append('select', id);
    if (name) searchParams.append('select', name);
    const url = `/cities?${searchParams.toString()}`;

    try {
        const {
            data: { data },
        } = await get(url);

        return data;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const getAgencies = async (params = {}) => {
    const url = '/agencies';

    try {
        const response = await get(url);

        return response;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

/**
 * Fetches all agencies and their partner/city data across all types.
 * Used for LYT-internal roles who need visibility of every agency.
 *
 * Endpoint: GET /agencies/alltypes
 *
 * The API returns flat rows — one row per partner × agency combination:
 *   { partner_abbreviation, partner_name, center_latitude, center_longitude,
 *     timezone, agency_abbreviation, agency_name, agency_type,
 *     region_abbreviation, region_name, region_center_latitude, region_center_longitude }
 *
 * @returns {Promise<Array>} Raw array of flat rows from the API
 */
export const getAllAgencyTypes = async () => {
    const url = '/agencies/alltypes';

    try {
        const response = await get(url);
        // The response has the rows array directly in data
        return response?.data?.rows || response?.data || [];
    } catch (err) {
        console.error('Error fetching all agency types:', err);
        throw err;
    }
};
